import { ClassProvider } from '@angular/core';

import Settings from './settings';
import { Types } from '../../../domain/types.domain';

export class SettingsInstruction implements ClassProvider {
  provide = Types.Settings;
  useClass = Settings;
}
